import React, { useState, useEffect } from "react";
import TextInput from "../../fields/TextInput";
import google from "../../../assets/assets/images/social_icons/google.png";
import facebook from "../../../assets/assets/images/social_icons/facebook.png";
import { Link, useNavigate } from "react-router-dom";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  Signup,
  cleanLogin,
  cleanUp,
  cleanupSignupNotif,
  getUserDetail,
  storeEmail,
  storeSocialData,
} from "../../../redux/Slice/authSlice";
import { ClipLoader } from "react-spinners";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signupUserDetail = useSelector((state) => state?.auth?.signupDetail);
  const loginStatus = useSelector((state) => state?.auth?.signupStatus);

  const [errmsg, setErrMsg] = useState({
    email: "",
    phone: "",
    password: "",
    fullName: "",
  });
  const [phone, setPhone] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countyCode, setCountyCode] = useState(null);
  const [pwdHide, setPwdHide] = useState(false);

  const [signupDetail, setSignupDetail] = useState({
    fullName: "",
    email: "",
    password: "",
  });

  const [user, setUser] = useState(null);
  const baseURL = useSelector((state) => state?.config?.baseURL);

  const handleChange = (newPhone,info) => {
    setPhone(newPhone);
    setCountyCode(info?.countryCallingCode);
    setPhoneNumber(info?.nationalNumber);
    setErrMsg((prev) => ({ ...prev, phone: "" }));
  };
  const userNameRegex = /^[A-Za-z\s]+$/;
  const handleInput = (event) => {
    const { name, value } = event.target;
    if (name === "fullName") {
      if (value === "" || userNameRegex.test(value)) {
        setSignupDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
      }
    } else
      setSignupDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
    setErrMsg((prev) => ({ ...prev, [name]: "" }));
  };

  function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  function isValidFullName(fullName) {
    const pattern = /^[A-Za-z\s]+$/;
    return pattern.test(fullName);
  }

  const Googlelogin = useGoogleLogin({
    client_id: googleClientId,
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`
        )
        .then((res) => {
          axios
            .post(`${baseURL}/signupuser/socialLogin`, res.data)
            .then((response) => {
              if (response.data.success === true) {
                // const logintoken = response.data.token;
                // var expirationDate = new Date();
                // expirationDate.setTime(expirationDate.getTime() + (1  60  60 * 1000));
                // expirationDate.setTime(expirationDate.getTime() + (1 * 60 * 60 * 1000));
                // Cookies.set('loginToken', logintoken, { expires: expirationDate });
                dispatch(storeSocialData(response.data));
                navigate("/");
              } else {
                toast(response.data.message);
              }
            })
            .catch((error) => {
              console.error("Error sending data to checkGoogleLogin:", error);
            });
        })
        .catch((err) =>
          console.log("Error fetching user info from Google:", err)
        );
    }
  }, [user, navigate]);

  useEffect(() => {
    if (signupUserDetail?.success === true) {
      dispatch(storeEmail(signupUserDetail?.data.emailId));
      navigate("/otp/signup");
      // dispatch(getUserDetail(signupUserDetail?.data?._id))
      // if (loginStatus === "fulfilled") {
      //     notify()
      // }
    }
  }, [signupUserDetail]);

  useEffect(() => {
    return () => {
      dispatch(cleanupSignupNotif());
    };
  }, []);
  useEffect(() => {
    return () => {
      dispatch(cleanUp());
    };
  }, []);

  const notify = () => toast("Sign up successful!");

  const handleSubmit = (e) => {
    e.preventDefault();
    const isPhoneValid = matchIsValidTel(phone);
    const mailValid = isValidEmail(signupDetail.email);
    const isFullNameValid = isValidFullName(signupDetail.fullName);

    let newErrMsg = {};
    if (signupDetail.fullName.trim() === "") {
      newErrMsg = { ...newErrMsg, fullName: "Please Enter Full Name" };
    } else if (!isFullNameValid) {
      newErrMsg = {
        ...newErrMsg,
        fullName: "Full Name should contain only letters and spaces",
      };
    }
    if (mailValid === false)
      newErrMsg = { ...newErrMsg, email: "Please Enter valid Mail" };
    if (signupDetail.password.length < 6)
      newErrMsg = {
        ...newErrMsg,
        password: "Password must be at least 6 characters long",
      };
    if (!isPhoneValid)
      newErrMsg = { ...newErrMsg, phone: "Please Enter valid Phone" };

    setErrMsg(newErrMsg);

    if (
      mailValid === false ||
      !isPhoneValid ||
      signupDetail.fullName.trim() === "" ||
      signupDetail.password.length < 6 ||
      isFullNameValid === false
    ) {
      return;
    } else {
      // dispatch(
      //   Signup({
      //     name: signupDetail?.fullName,
      //     email: signupDetail?.email,
      //     phoneNumber: phone,
      //     password: signupDetail?.password,
      //   })
      // );
      dispatch(
        Signup({
          name: signupDetail?.fullName,
          email: signupDetail?.email,
          phoneNumber: phoneNumber,
          country_code: "+"+countyCode,
          password: signupDetail?.password,
        })
      );
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid px-0">
      <div className="slider_img ">
        <div className="row mx-0 z_999">
          <div className="col-lg-4 px-0">
            <div className="login-div mx-1">
              <h2 className="font accentColor">Sign up</h2>
              <div className="mt-1 text-start">
                <p className="secondaryColor fs14">
                  Already have an account?{" "}
                  <span>
                    <Link to="/login" className="accentColor">
                      LogIn
                    </Link>
                  </span>
                </p>
              </div>
              <div className="mt-2">
                <div className="row">
                  <div className="mb-2 col-12">
                    <p className="accentColor mb-1 fs14">
                      Email<span style={{ color: "red" }}>*</span>
                    </p>
                    <TextInput
                      type="email"
                      // id="email"
                      size="small"
                      name="email"
                      value={signupDetail.email}
                      formPlaceholder="Enter Your Email"
                      shrink="false"
                      animation="true"
                      onChange={handleInput}
                      error={!!errmsg?.email}
                      helperText={errmsg?.email}
                      requiredStar={true}
                    />
                  </div>
                  <div className="mb-2 col-12">
                    <p className="accentColor mb-1 fs14">
                      Phone Number<span style={{ color: "red" }}>*</span>
                    </p>
                    <MuiTelInput
                      // disableFormatting
                      error={!!errmsg?.phone}
                      defaultCountry="ZM"
                      value={phone}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                      sx={{ width: "100%" }}
                      helperText={errmsg?.phone}
                    />
                  </div>
                  <div className="mb-2 col-md-6">
                    <p className="accentColor mb-1 fs14">
                      Full Name<span style={{ color: "red" }}>*</span>
                    </p>
                    <TextInput
                      type="text"
                      // id="fullname"
                      size="small"
                      name="fullName"
                      value={signupDetail.fullName}
                      formPlaceholder="Enter Full Name"
                      shrink="false"
                      animation="true"
                      onChange={handleInput}
                      error={!!errmsg?.fullName}
                      helperText={errmsg?.fullName}
                      requiredStar={true}
                    />
                  </div>
                  <div className="mb-2 col-md-6">
                    <p className="accentColor mb-1 fs14">
                      Password<span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="position-relative">
                      <TextInput
                        type={pwdHide ? "text" : "password"}
                        id="password"
                        size="small"
                        name="password"
                        value={signupDetail.password}
                        formPlaceholder="Enter Password"
                        shrink="false"
                        animation="true"
                        onChange={handleInput}
                        error={!!errmsg?.password}
                        helperText={errmsg?.password}
                        requiredStar={true}
                      />
                      <span className="position-absolute eye">
                        {pwdHide ? (
                          <FaRegEye onClick={() => setPwdHide(!pwdHide)} />
                        ) : (
                          <FaRegEyeSlash onClick={() => setPwdHide(!pwdHide)} />
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                {signupUserDetail?.success === false ? (
                  <p className="location-err">{signupUserDetail?.message}</p>
                ) : null}
                <button
                  onClick={(e) => {
                    scrollToTop();
                    handleSubmit(e);
                  }}
                  type="button"
                  className="btn w-100 grid-class mt-3 img-btn primaryColor"
                >
                  {loginStatus === "pending" ? null : "Sign up"}
                  <ClipLoader
                    loading={loginStatus === "pending" ? true : false}
                    cssOverride={{ width: "25px", height: "25px" }}
                    color="#fff"
                  />
                </button>
                <h5 className="text-center my-2">Or</h5>
                <div className="signup-social">
                  <button
                    type="button"
                    className="login-with-google-btn"
                    onClick={() => Googlelogin()}
                  >
                    <img src={google} className="google-icon" />
                    Sign in with Google
                  </button>
                  {/* <button type="button" className="login-with-google-btn" >
                                        <img src={facebook} className='facebook-icon' />
                                        Sign in with Facebook
                                    </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
